import { gql } from '@apollo/client';
import { useMutation } from 'platform/useMutation';
import {
  ScheduleExteriorAssessmentMutation as ScheduleMutation,
  ScheduleExteriorAssessmentMutationVariables,
} from 'sellDirect/graphql/__generated__/ScheduleExteriorAssessmentMutation';
import { GET_ALL_EXTERIOR_ASSESSMENT_SLOTS } from 'sellDirect/graphql/useGetAllExteriorAssessmentSlots';
import { ZonedDateTime } from '@js-joda/core';

export const SCHEDULE_EXTERIOR_ASSESSMENT = gql`
  mutation ScheduleExteriorAssessmentMutation(
    $sellerInputUUID: String!
    $selectedInspectionTime: DateTime!
  ) {
    web {
      scheduleExteriorAssessment(
        input: {
          sellerInputUUID: $sellerInputUUID
          selectedInspectionTime: $selectedInspectionTime
        }
      ) {
        visitId
      }
    }
  }
`;

const transformData = (data?: ScheduleMutation | null) => {
  if (!data?.web?.scheduleExteriorAssessment) return;
  const assessmentData = data?.web?.scheduleExteriorAssessment;

  return {
    visitId: assessmentData?.visitId,
  };
};

/** TODO: Add documentation */
export const useScheduleExteriorAssessment = (sellerInputUUID: string) => {
  const [ScheduleExteriorAssessment, { data, loading, error }] = useMutation<
    ScheduleMutation,
    ScheduleExteriorAssessmentMutationVariables
  >(SCHEDULE_EXTERIOR_ASSESSMENT, {
    awaitRefetchQueries: true,
    fetchPolicy: 'no-cache',
    refetchQueries: [{ query: GET_ALL_EXTERIOR_ASSESSMENT_SLOTS, variables: { sellerInputUUID } }],
  });

  const scheduleExteriorAssessment = (selectedInspectionDate: ZonedDateTime) => {
    ScheduleExteriorAssessment({
      variables: {
        sellerInputUUID,
        selectedInspectionTime: selectedInspectionDate.toInstant().toString(),
      },
    });
  };

  return { scheduleExteriorAssessment, data: transformData(data), loading, error };
};
